import { useState } from 'react';
import Modal from 'src/components/common/modal/Modal';
import Form from '../Form';
import { Button } from '@habitech/call-to-action';
import Icon from 'src/components/common/Icon';
import Title from 'src/components/common/Title';

const EditProgram = ({ initialValues, setLoadingList }) => {
    const [showEdit, setShowEdit] = useState(false);
    return (
        <>
            <Button dataId="test-id" variant="stroke" originType="pcom" size="medium" onClick={() => setShowEdit(true)}>
                Editar<Icon className="icon-edit" icon="pcom-icon-edition" size={18} />
            </Button>
            {showEdit && (
                <Modal onClose={() => setShowEdit(false)}>
                    <div style={{ textAlign: 'center', paddingTop: '16px' }}>
                        <Title>Editar Programa ({initialValues.name})</Title>
                    </div>
                    <Form type="Editar" initialValues={initialValues} onCloseModal={setShowEdit} setLoadingList={setLoadingList} />
                </Modal>
            )}
        </>
    );
};

export default EditProgram;
